export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0017s_0000_Black-&-White-39.4696cd12.png";